<template>
  <footer>
    <div class="reassurance light-grey">
      <div class="container">
        <div class="carousel-container" ref="carouselMain">
          <ul ref="carousel">
            <li v-for="item in carousel" :key="item.icon">
              <template v-if="item.android && isAndroid">
                <a :href="item.android" target="_blank">
                  <img :src="item.icon"/>
                </a>
              </template>
              <template v-if="item.ios && isIOS">
                <a :href="item.ios" target="_blank">
                  <img :src="item.icon"/>
                </a>
              </template>
              <template v-if="(!item.ios && !item.android) || (!isAndroid && !isIOS)">
                <img :src="item.icon"/>
              </template>
            </li>
          </ul>
        </div>
      </div>
      <div class="topfooter">
        <div class="container">
          <div class="page">
            <div class="col1">
              <div class="footer-logo">
                <img src="/static/img/MiH-white.svg">
              </div>
              <p>{{ $t('footer.leftText') }}</p>
            </div>
            <div class="col2">
              <h3>{{ $t('footer.title.rooms').toUpperCase() }}</h3>
              <ul>
                <li v-for="(room, index) in rooms" :key="room.id" :index="index" :item="room">
                  <router-link tag="a"
                               :to="{name: 'room', params: {id: room.id, slug: slug(room.text)}}">
                    {{ room.text }}
                  </router-link>
                </li>
                <li class="allsuites2">
                  <router-link tag="a" :to="{name: 'search'}"><span>...</span></router-link>
                </li>
              </ul>
            </div>
            <div class="col3">
              <ul>
                <li>
                  <router-link tag="a" :to="{name: 'home'}">{{ $t('footer.list.home') }}</router-link>
                </li>
                <li>
                  <router-link tag="a" :to="{name: 'concept', params: {conceptMenuId: 1}}">
                    {{ $t('footer.list.concept') }}
                  </router-link>
                </li>
                <li>
                  <router-link tag="a" :to="{name: 'search', params: {runAuto: true}}">{{ $t('footer.list.rooms') }}
                  </router-link>
                </li>
                <li>
                  <router-link tag="a" :to="{name: 'extras'}">{{ $t('footer.list.extras') }}
                  </router-link>
                </li>
                <li><a :href="`https://blog.mihotel.fr/${blogLang}`" target="_blank">{{ $t('footer.list.blog') }}</a>
                </li>
                <li>
                  <a
                    :href="`https://reviews.customer-alliance.com/hotel/mihotel-lyon-5bfb41e46b59b2cf.html?_locale=${lang}`"
                    target="_blank">{{ $t('footer.list.advices') }}</a>
                </li>
                <li>
                  <a :href="BUSINESS_LINK" target="_blank">{{ $t('topbar.menu.business') }}</a>
                </li>
                <li>
                  <router-link tag="a" :to="{name: 'invest'}">{{ $t('footer.list.invest') }}</router-link>
                </li>
                <li>
                  <router-link tag="a" :to="{name: 'faq'}">{{ $t('faq.title') }}</router-link>
                </li>
                <li>
                  <a :href="$t('footer.list.RSE_link')" target="_blank">{{ $t('footer.list.RSE') }}</a>
                </li>
              </ul>
            </div>
            <div class="col4">
              <h3>{{ $t('footer.contact.title').toUpperCase() }}</h3>
              <p><a :href="`mailto:${$t('footer.contact.email')}`">{{ $t('footer.contact.email') }}</a></p>
              <p>{{ $t('footer.contact.address1') }} </br>{{ $t('footer.contact.address2') }} </br>
                {{ $t('footer.contact.address3') }}</p>
              <p>{{ $t('footer.contact.phone') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footerbottom">
        <div class="container">
          <div class="page">
            <div class="socials">
              <a href="https://www.facebook.com/mihotel.fr/" class="facebook" target="_blank">
                <svg id="Bold" enable-background="new 0 0 24 24" height="512" viewBox="0 0 24 24"
                     width="512"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill="#FFF"
                        d="m15.997 3.985h2.191v-3.816c-.378-.052-1.678-.169-3.192-.169-3.159 0-5.323 1.987-5.323
                    5.639v3.361h-3.486v4.266h3.486v10.734h4.274v-10.733h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077
                    2.051-2.077z"/>
                </svg>
              </a>
              <a href="https://twitter.com/mihotelfrance" class="twitter" target="_blank">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     x="0px" y="0px"
                     viewBox="0 0 1200 1227" style="enable-background:new 0 0 512 512;"
                     xml:space="preserve">
                  <path fill="#FFF"
                        d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"></path>
            </svg>
              </a>
              <a href="https://www.instagram.com/mi.hotel/" class="instagram" target="_blank">
                <svg id="Bold" enable-background="new 0 0 24 24" height="512" viewBox="0 0 24 24"
                     width="512"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill="#FFF"
                        d="m12.004 5.838c-3.403 0-6.158 2.758-6.158 6.158 0 3.403 2.758 6.158 6.158 6.158 3.403 0 6.158-2.758
                    6.158-6.158 0-3.403-2.758-6.158-6.158-6.158zm0 10.155c-2.209 0-3.997-1.789-3.997-3.997s1.789-3.997
                    3.997-3.997 3.997 1.789 3.997 3.997c.001 2.208-1.788 3.997-3.997 3.997z"/>
                  <path fill="#FFF"
                        d="m16.948.076c-2.208-.103-7.677-.098-9.887 0-1.942.091-3.655.56-5.036 1.941-2.308 2.308-2.013
                    5.418-2.013 9.979 0 4.668-.26 7.706 2.013 9.979 2.317 2.316 5.472 2.013 9.979 2.013 4.624 0
                    6.22.003 7.855-.63 2.223-.863 3.901-2.85 4.065-6.419.104-2.209.098-7.677 0-9.887-.198-4.213-2.459-6.768-6.976-6.976zm3.495
                    20.372c-1.513 1.513-3.612 1.378-8.468 1.378-5 0-7.005.074-8.468-1.393-1.685-1.677-1.38-4.37-1.38-8.453 0-5.525-.567-9.504
                    4.978-9.788 1.274-.045 1.649-.06 4.856-.06l.045.03c5.329 0 9.51-.558 9.761 4.986.057 1.265.07 1.645.07 4.847-.001 4.942.093 6.959-1.394 8.453z"/>
                  <circle fill="#FFF" cx="18.406" cy="5.595" r="1.439"/>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@mihotel_"  class="tiktok" target="_blank">
                <svg fill="#FFF" width="800px" height="800px" viewBox="0 0 512 512" id="icons" xmlns="http://www.w3.org/2000/svg"><path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/></svg>
              </a>
            </div>
            <div class="infolegal">
              <router-link tag="a" :to="{name: 'faq'}">{{ $t('faq.title') }}</router-link>
              <a href="javascript:void(0)" @click="cookieClick" v-if="!!axeptioSdk">{{ $t('footer.cookie') }}</a>
              <a href="javascript:void(0)" @click="openLegalModal(0)">{{ $t('footer.legal.notice') }}</a>
              <a href="javascript:void(0)" @click="openLegalModal(1)">{{ $t('footer.legal.tos') }}</a>
              <router-link tag="a" :to="{name: 'privacy'}">{{ $t('footer.legal.gdpr') }}</router-link>
              <span>{{ year }}©MiHotel</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import moment from 'moment';
import {TextHelper} from "../helpers/text.helper";
import {mapState} from "vuex";
import {BUSINESS_LINK} from '../common';

export default {
  name: 'app-footer',
  data() {
    return {
      year: moment().format('YYYY'),
      axeptioSdk: null,
      BUSINESS_LINK,
      carousel: [
        {icon: '/static/img/3dsecure.png'},
        {icon: '/static/img/visa.png'},
        {icon: '/static/img/americanexpress.png'},
        {icon: '/static/img/french_tech.png'},
        {icon: '/static/img/only_lyon.png'},
        {icon: '/static/img/assistance.png'},
        {icon: '/static/img/tripadvisor_2021.png'},
        {
          icon: '/static/img/application.png',
          android: 'https://play.google.com/store/apps/details?id=fr.mihotel.client.android&hl=fr&gl=US',
          ios: 'https://apps.apple.com/fr/app/mihotel-lh%C3%B4tel-autrement/id1451279299',
        },
        // {icon: '/static/img/customeralliance.png'},
      ],
    };
  },
  mounted() {
    window._axcb = window._axcb || [];
    window._axcb.push((sdk) => {
      this.axeptioSdk = sdk;
    });
    window.addEventListener('resize', this.initCarousel);
    this.initCarousel();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initCarousel);
  },
  computed: {
    rooms() {
      return [
        {id: 2, text: 'Confidence'},
        {id: 22, text: 'Nuances'},
        {id: 23, text: 'Cachette'},
        {id: 1, text: 'Hyggelig'},
        {id: 10, text: 'Bellecour'},
        {id: 11, text: 'Jungle'},
        {id: 12, text: 'Origine'},
        {id: 15, text: 'Balançoire'},
        {id: 43, text: 'Esmeralda'},
        {id: 16, text: 'Clotilde'},
        {id: 18, text: 'Monsieur'},
        {id: 19, text: 'Nova'},
        {id: 20, text: 'Sienna'},
        {id: 21, text: 'Entre soi'},
        {id: 24, text: 'Copper'},
        {id: 25, text: 'Rendez-vous'},
        {id: 29, text: 'Paradis'},
        {id: 30, text: 'Merveille'},
        {id: 31, text: 'Eden'},
        {id: 42, text: 'James'},
        {id: 33, text: 'Précieuse'},
        {id: 35, text: 'Fauve'},
        {id: 37, text: 'Envol'},
        {id: 38, text: 'Vertigo'},
      ]
    },
    ...mapState({
      lang: s => (s.lang.currentLang || 'fr').toLowerCase(),
      blogLang: s => {
        const lang = (s.lang.currentLang || 'fr').toLowerCase();
        if (lang === 'fr') return '';
        return lang;
      },
      isIOS: s => s.isIOS,
      isAndroid: s => s.isAndroid,
    })
  },
  methods: {
    initCarousel() {
      return false;
      const container = this.$refs.carouselMain;
      const inner = this.$refs.carousel;
      const width = container.clientWidth;
      const contentWidth = inner.scrollWidth;
      if (width >= contentWidth) return;
      this.$refs.carousel.animate([
        {transform: 'translateX(0px)'},
        {transform: 'translateX(0px)'},
        {transform: `translateX(${width - contentWidth}px)`},
        {transform: `translateX(${width - contentWidth}px)`},
      ], {
        direction: 'alternate',
        duration: 6000,
        iterations: Infinity
      })
      console.log({width, contentWidth});
    },
    slug(txt) {
      return TextHelper.slugify(txt)
    },
    openLegalModal(number) {
      this.$store.commit('legalModal/SET_TAB', number);
      this.$store.commit('legalModal/OPEN_MODAL');
    },
    cookieClick() {
      window.showAxeptioButton();
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footer.vue